import axios from 'axios';

axios.interceptors.response.use((res) => {
  console.log('6666666666')
  this.$loadingHide();
  if (!res.success) {
    this.$toast(res.retMsg);
  }
  return res.data;
}, (error) => {
  console.log('555555555555')
  this.$loadingHide();
  this.$toast('出错啦，请重试~');
  return Promise.reject(error);
});

function ajax (opt) {
  return new Promise((resolve, reject) => {
    const { type, url, data, conf, noLoading } = opt;
    !noLoading && this.$loading();
    if (type === 'get') {
      axios.get(url, conf).then(resolve, reject);
    } else if (type === 'post') {
      axios.post(url, data, conf).then(resolve, reject);
    }
  });
}

const http = {
  get (url, conf, noLoading) {
    if (typeof conf === 'boolean') {
      noLoading = conf;
    }
    return ajax({
      type: 'get',
      url,
      conf,
      noLoading,
    });
  },
  post (url, data, conf, noLoading) {
    if (typeof data === 'boolean' || typeof conf === 'boolean') {
      noLoading = data || conf;
    }
    return ajax({
      type: 'post',
      url,
      data,
      conf,
      noLoading,
    });
  },
};

export default http;
